import { Link } from "react-router-dom";

import MetricCard from "../../components/director/module1/MetricCard";
import ModuleShell from "../../components/director/module1/ModuleShell";
import ModuleState from "../../components/director/module1/ModuleState";
import useDirectorSurface from "../../components/director/module1/useDirectorSurface";
import { useDirectorContext } from "@contexts/director";
import { companyQuery } from "./module1Utils";

const labels = {
  executive: "Visão executiva",
  liquidity: "Liquidez e caixa",
  receivables: "Clientes e recebimentos",
  dre: "DRE gerencial",
  return: "Retorno",
  centers_titles: "Centros e títulos",
  scenarios: "Cenários",
  governance: "Governança dos dados",
};

const targets = {
  executive: "/dashboard/director/overview",
  liquidity: "/dashboard/director/liquidity/weekly",
  receivables: "/dashboard/director/customer-receipts",
  dre: "/dashboard/director/dre",
  return: "/dashboard/director/returns",
  centers_titles: "/dashboard/director/centers",
  scenarios: "/dashboard/director/scenarios",
  governance: "/dashboard/director/governance",
};

const DirectorEntry = () => {
  const { selectedCompanyId, metadata } = useDirectorContext();
  const surface = useDirectorSurface("entry");
  const entities = metadata?.legalEntities || [];
  const projects = metadata?.projects || [];
  const centers = metadata?.costCenters || [];
  return <ModuleShell
    title="Escolha o portfólio econômico"
    description="Comece pelo grupo consolidado e preserve os limites jurídicos de cada caixa."
    badge="Regime A · fluxo sem saldo"
  >
    <ModuleState {...surface} availability={surface.data?.availability} onRetry={surface.reload} />
    {surface.data && <>
      <section className="director-module1__metrics">
        <MetricCard label="Empresas e SPEs" value={entities.length} note="Escopo autorizado" />
        <MetricCard label="Empreendimentos" value={projects.length} note="Vínculos governados" tone="blue" />
        <MetricCard label="Centros de custo" value={centers.length} note="Classificação financeira" tone="orange" />
      </section>
      <section className="director-module1__split">
        <article className="director-module1__panel">
          <header><span className="director-eyebrow">Módulo 1</span><h2>{surface.data.portfolioName}</h2></header>
          <div className="director-module1__section-list">
            {(surface.data.sections || []).map((item) => <Link key={item.key} to={`${targets[item.key]}${companyQuery(selectedCompanyId)}`}>
              <span>{labels[item.key] || item.key}</span>
              <small data-status={item.status}>{item.status === "available" ? "Disponível" : item.status === "partial" ? "Parcial" : "Aguardando dados"}</small>
            </Link>)}
          </div>
        </article>
        <aside className="director-module1__insight">
          <span className="director-eyebrow">Como interpretar</span>
          <h2>Uma visão do grupo, sem misturar saldos</h2>
          <p>Entradas e saídas são consolidadas por empresa, projeto e centro. Como não há saldo declarado, nenhuma tela afirma caixa negativo ou necessidade de capital.</p>
          <div className="director-module1__callout">Escopo auditável · {surface.data.portfolioVersion ? `portfólio v${surface.data.portfolioVersion}` : "versão disponível"}</div>
          <Link className="director-button" to={`/dashboard/director/overview${companyQuery(selectedCompanyId)}`}>Entrar na visão consolidada</Link>
        </aside>
      </section>
    </>}
  </ModuleShell>;
};

export default DirectorEntry;
